<div *ngIf="showViewHTMLComponent">
  <div *ngIf="originalData.length > 0">
    <div class="search-results-bar">
      <input type="text" class="search-input-results" (input)="applyFilter()" placeholder="Buscar" name="filtro"
        [(ngModel)]="filterTerm">
      <button class="search-button" (click)="applyFilter()">
        <span class="material-symbols-outlined">
          search
        </span>
      </button>
    </div>
    <div id="data-table-component" class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>
              <div (click)="sortTable('vigencia')">
                <span>Vigencia</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'vigencia' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'vigencia' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'vigencia'">unfold_more</span>
              </div>
            </th>
            <th>
              <div (click)="sortTable('nombrePeriodo')">
                <span>Periodo</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'nombrePeriodo' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'nombrePeriodo' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'nombrePeriodo'">unfold_more</span>
              </div>
            </th>
            <th>
              <div (click)="sortTable('nroReferencia')">
                <span>No. de referencia</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'nroReferencia' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'nroReferencia' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'nroReferencia'">unfold_more</span>
              </div>
            </th>
            <th>
              <div (click)="sortTable('fechaCreacion')">
                <span>Fecha de creación</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'fechaCreacion' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'fechaCreacion' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'fechaCreacion'">unfold_more</span>
              </div>
            </th>
            <th>
              <div (click)="sortTable('fechaPago')">
                <span>Fecha límite del formulario para firmas</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'fechaPago' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'fechaPago' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'fechaPago'">unfold_more</span>
              </div>
            </th>
            <th>
              <div (click)="sortTable('descEstado')">
                <span>Estado</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'descEstado' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'descEstado' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'descEstado'">unfold_more</span>
              </div>
            </th>
            <th>
              <div (click)="sortTable('valorPagar')">
                <span>Valor</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'valorPagar' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'valorPagar' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'valorPagar'">unfold_more</span>
              </div>
            </th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of paginatedData">
            <td>{{item.vigencia}}</td>
            <td>{{item.nombrePeriodo}}</td>
            <td>{{item.nroReferencia }}</td>
            <td>{{item.fechaCreacion }}</td>
            <td>{{item.fechaPago }}</td>
            <td>{{item.descEstado}}</td>
            <td>{{item.valorPagar | currency:'COP':'$':'1.0-0'}}</td>
            <td>
              <div class="cell-table-actions">
                <a href="javascript:void(0)" class="a-action-primary" (click)="elementoAFirmarParaModal(item)">Firmar</a>
                <div class="dropdown">
                  <span (click)="toggleMenu(item)" class="material-symbols-outlined material-symbols-filled" title="Ver más acciones" style="padding: 0px 20px;cursor: pointer;" [class.active]="item.$$isMenuOpen">
                    more_vert
                  </span>
                  <ul class="dropdown-content" [class.show]="item.$$isMenuOpen">
                    <li><a href="javascript:void(0)" (click)="getFormulario(item)"><span class="material-symbols-outlined material-symbols-filled">archive</span>Descargar</a></li>
                    <li><a href="javascript:void(0)" (click)="elementoAEliminarParaConfirmar(item)"><span class="material-symbols-outlined material-symbols-filled">delete</span>Eliminar</a></li>
                  </ul>
                </div>
              </div>
            </td>
          </tr>
          <tr *ngIf="paginatedData.length == 0 && originalData.length > 0" >
            <td colspan="7" style="text-align: center;">
              No se encontraron resultados asociados a tu búsqueda.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination" *ngIf="pageNumbers.length != 0 && this.originalData.length > this.rowsPerPage">
      <span class="pagination-text control_boton_paginacion_1" (click)="prevPage()"
        [ngClass]="{ 'enabled-control-button' : currentPage !== 1 }">Anterior</span>
      <span class="pagination-text material-symbols-outlined material-symbols-filled control_boton_paginacion_2" (click)="prevPage()"
        [ngClass]="{ 'enabled-control-button' : currentPage !== 1 }">arrow_back_ios</span>
      <ng-container *ngFor="let page of pageNumbers">
        <button *ngIf="page !== '...'; else ellipsis" class="page-button" [class.active]="page === currentPage"
          (click)="goToPage(page)"> {{page}}</button>
        <span>
        </span>
        <ng-template #ellipsis>
          <span class="ellipsis enabled-control-button w700">...</span>
        </ng-template>
      </ng-container>
      <span class="pagination-text control_boton_paginacion_1" (click)="nextPage()"
        [ngClass]="{ 'enabled-control-button' : currentPage !== totalPages && totalPages !== 0 }">Siguiente</span>
      <span class="pagination-text material-symbols-outlined material-symbols-filled control_boton_paginacion_2" (click)="nextPage()"
        [ngClass]="{ 'enabled-control-button' : currentPage !== totalPages && totalPages !== 0 }">arrow_forward_ios</span>
    </div>
  </div>
  <div class="container-body-tab-item-result" *ngIf="originalData.length == 0">
    <div class="container-body-tab-item-result-view">
      <span class="material-symbols-outlined material-symbols-filled header-icon alert-info">event_available</span>
      <p class="header-icon-title alert-info" >Sin formularios pendientes de firma</p>
      <p class="body-seccion">No hay formularios pendientes de firma en este momento.<br> Cuando se generen formularios pendientes de firma, aparecerán aquí para que los gestiones fácilmente.</p>
    </div>
  </div>
</div>


<div *ngIf="abrirModalEliminar" class="general-modal">
  <div class="general-modal-contenido">
    <span class="general-cerrar-modal" (click)="cerrarDialogoFinalizacionEliminar()">&times;</span>
    <div>
      <div>
        <span class="material-symbols-outlined material-symbols-filled header-icon alert-error">delete</span>
        <p class="header-icon-title alert-error">Estás a punto de eliminar el formulario</p>
        <p class="body-modal">¿Está seguro que desea anular el formulario?</p>
      </div>
      <div class="container-confir-modal">
        <button class="btn-white-secun" (click)="cerrarDialogoFinalizacionEliminar()">
          NO, CANCELAR
        </button>
        <button class="btn-danger-primary" (click)="eliminarFilaFormulario()">
          SÍ, ELIMINAR
        </button>
      </div>
      <div></div>
    </div>
  </div>
</div>


<div *ngIf="abrirModalFirma" class="general-modal">
  <div class="general-modal-contenido general-modal-contenido-form-firmar">
    <div>
      <div class="form-header-firmar">
        <h3>Firma electrónica</h3>
        <p>Debes firmar electrónicamente este documento para validarlo y continuar.</p>
      </div>
      <hr>
      <div class="form-body-firmar">
        <div class="row form-gap-row">
          <div class="form-field">
            <label for="usuarioRol" class="form-required">Rol</label>
            <select class="form-select" [formControl]="usuarioRol" name="usuarioRol" id="usuarioRol" (change)="cambiaRol()">
              <option [ngValue]="''">Selecciona una opción</option>
              <option *ngFor="let role of roles" [ngValue]="role.codigo">{{role.nombre}}</option>
            </select>
          </div>
          <div class="form-field">
            <label for="usuarioTipoId" class="form-required">Tipo de documento</label>
            <select class="form-select" [formControl]="usuarioTipoId" name="usuarioTipoId" id="usuarioTipoId">
              <option [ngValue]="''">Selecciona una opción</option>
              <option *ngFor="let tipoId of tiposId" [ngValue]="tipoId.cod">{{tipoId.desc}}</option>
            </select>
          </div>
          <div class="form-field">
            <label for="numeroDocumento" class="form-required">Número de documento</label>
            <input type="text" placeholder="Escriba la información solicitada" class="lowerCase form-control"
              id="numeroDocumento" [formControl]="usuarioNroId" name="numeroDocumento" capitalize="capitalize" readonly="readonly">
          </div>
          <div class="form-field">
            <div class="form-group">
              <label for="clave" class="form-required">Contraseña</label>
              <div class="password-container">
                <input [type]="passwordVisible ? 'text' : 'password'" placeholder="Escriba la información solicitada"
                  class="password-input" id="clave" name="clave" [formControl]="usuarioPassword" autocomplete="off">
                <button type="button" class="toggle-password-btn" (click)="togglePasswordVisibility()">
                  <span class="material-symbols-outlined material-symbols-filled icon-password-color">
                    {{ !passwordVisible ? 'visibility_off' : 'visibility' }}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <a class="text-simple" [href]="this.urlRecuperarClave" *ngIf="this.urlRecuperarClave" target="_blank">Olvidé
            mi contraseña</a>
          <a class="text-simple" [href]="this.urlAuti" *ngIf="this.urlAuti" target="_blank">Registrarse</a>
        </div>
      </div>
      <div class="container-confir-modal container-confir-modal-form-firma">
        <button class="btn-white-secun" (click)="cerrarDialogoFinalizacionFirma()">
          CANCELAR
        </button>
        <button class="btn-normal-primary" (click)="verifyUser()" [disabled]="!isValidFormFirmar()">
          FIRMAR
        </button>
      </div>
      <div></div>
    </div>
  </div>
</div>